import { createContext, useCallback, useContext, useState } from 'react';
import { AchievementToast, type Achievement } from './AchievementToast';

interface AchievementContextValue {
  showAchievement: (achievement: Achievement) => void;
}

const AchievementContext = createContext<AchievementContextValue>({
  showAchievement: () => {},
});

export function useAchievements() {
  return useContext(AchievementContext);
}

interface QueueItem {
  id:          string;
  achievement: Achievement;
}

export function AchievementProvider({ children }: { children: React.ReactNode }) {
  const [queue, setQueue] = useState<QueueItem[]>([]);

  const showAchievement = useCallback((achievement: Achievement) => {
    setQueue(q => [...q, { id: `${achievement.id}-${Date.now()}`, achievement }]);
  }, []);

  function dismiss(itemId: string) {
    setQueue(q => q.filter(i => i.id !== itemId));
  }

  return (
    <AchievementContext.Provider value={{ showAchievement }}>
      {children}
      {/* Render queue stacked from bottom */}
      <div className="fixed bottom-6 right-4 z-50 flex flex-col gap-3 pointer-events-none">
        {queue.map((item, idx) => (
          <div key={item.id} className="pointer-events-auto" style={{ marginBottom: idx > 0 ? '0.5rem' : 0 }}>
            <AchievementToast
              achievement={item.achievement}
              onClose={() => dismiss(item.id)}
            />
          </div>
        ))}
      </div>
    </AchievementContext.Provider>
  );
}
